import React from "react"
import styled from "styled-components"

import {CheckoutRedemptionOrder, Deal} from "@irati/types"
import {Row} from "@irati/ui/src/ColumnRow"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {Card} from "@irati/ui/src/Layout"
import {H4} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import SummaryProductInfo from "../../MerchandiseOrderSummary/SummaryProductInfo"
import {AddressInfo} from "../../OrderAddressInfo/AddressInfo"
import OrderInfoCol from "./OrderInfoCol"

type Props = Required<Pick<CheckoutRedemptionOrder & Deal, "uuid" | "basket" | "cardImage" | "header">>

const OrderInfoSection = ({uuid, cardImage, header, basket: {shippingAddress, total}}: Props) => {
  return (
    <Card padding={[2]}>
      <Title paddingTop={theme.spacing.one} weight="bold">
        <FormattedMessage
          id="flexiRewards.merchandise.success.orderId"
          values={{
            orderId: uuid.toUpperCase()
          }}
        />
      </Title>

      <Flex wrap="wrap">
        <OrderInfoCol headerId="flexiRewards.merchandise.success.deliveryAddress">
          <Row padding={0}>
            <AddressInfo shippingAddress={shippingAddress!} />
          </Row>
        </OrderInfoCol>

        <OrderInfoCol headerId="flexiRewards.merchandise.success.item.header">
          <SummaryProductInfo cardImage={cardImage} header={header} price={total!.amount} />
        </OrderInfoCol>
      </Flex>
    </Card>
  )
}

const Title = styled(H4)`
  max-width: 165px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export default OrderInfoSection
